
import { defineComponent } from 'vue'

export default defineComponent({
  setup(props, context) {
    const clickClose = () => {
      context.emit('close')
    }
    return {
      clickClose
    }
  }
})
